import { CoreModule } from '@abp/ng.core';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { NgModule } from '@angular/core';
import { CommercialUiModule } from '@volo/abp.commercial.ng.ui';
import { ThemeSharedModule } from '@abp/ng.theme.shared';
import { NgxValidateCoreModule } from '@ngx-validate/core';
import { NotificationBellComponent } from "./components/notification-bell/notification-bell.component";
import { NotificationPanelComponent } from "./components/notification-panel/notification-panel.component";
import { CidadeSelectComponent } from './components/reference-selects/cidade-select/cidade-select.component';
import { MesorregiaoSelectComponent } from './components/reference-selects/mesorregiao-select/mesorregiao-select.component';

@NgModule({
  declarations: [
    NotificationBellComponent,
    NotificationPanelComponent,],
  imports: [
    CoreModule,
    ThemeSharedModule,
    CommercialUiModule,
    NgbDropdownModule,
    NgxValidateCoreModule,
    CidadeSelectComponent,
    MesorregiaoSelectComponent,

  ],
  exports: [
    CoreModule,
    ThemeSharedModule,
    CommercialUiModule,
    NgbDropdownModule,
    NgxValidateCoreModule,
    NotificationBellComponent,
    NotificationPanelComponent,
    CidadeSelectComponent,
    MesorregiaoSelectComponent,
  ],
  providers: []
})
export class SharedModule {}
